import SubmissionError from '../error/SubmissionError'
import Vue from 'vue'
import { isNoAuthRoute } from '@/router'

const jsonLdMimeType = 'application/ld+json'
export const CORE_API_HOST = process.env.VUE_APP_CORE_API_HOST
export const API_PATH = process.env.VUE_APP_API_PATH

export default function(url, options = {}) {
  if (typeof options.headers === 'undefined') Object.assign(options, { headers: new Headers() })

  if (options.headers.get('Accept') === null) options.headers.set('Accept', jsonLdMimeType)

  if (options.headers.get('Authorization') === null)
    options.headers.set('Authorization', 'Bearer ' + Vue.keycloak.token)

  if (
    options.body !== undefined &&
    !(options.body instanceof FormData) &&
    options.headers.get('Content-Type') === null
  ) {
    options.headers.set('Content-Type', jsonLdMimeType)
  }

  let link = url.includes(API_PATH) ? CORE_API_HOST + url : CORE_API_HOST + API_PATH + url

  return Vue.keycloak
    .updateToken(30)
    .then(() => {
      return fetch(link, options).then(response => {
        if (response.ok) return response

        if (401 === response.status) {
          response.text().then(body => {
            if (body.indexOf('Invalid access token') !== -1 || body.indexOf('Invalid credentials') !== -1) {
              // eslint-disable-next-line no-console
              console.log('Invalid credentials')
              if (!isNoAuthRoute()) {
                Vue.keycloak.login({
                  redirectUri: window.origin + '/auth-callback'
                })
              }
            }
          })
        } else {
          return response.json().then(json => {
            const error = json['hydra:description'] ? json['hydra:description'] : response.statusText
            if (!json.violations) throw Error(error)

            const errors = { _error: error }
            json.violations.map(violation => Object.assign(errors, { [violation.propertyPath]: violation.message }))

            throw new SubmissionError(errors)
          })
        }
      })
    })
    .catch(e => {
      if ('Forbidden' === e.message) {
        // eslint-disable-next-line no-console
        console.log(e)
        Vue.keycloak.login({
          redirectUri: window.origin + '/auth-callback'
        })
      } else {
        throw e
      }
    })
}
